import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router';
import { Redirect } from 'react-router-dom';
import { Home } from './components/Home';
import { Users } from './components/Users/Users';
import NoAccess from './components/Shared/NoAccess';
import { api, entrataAPI, resetUserToken } from './api/create-api';
import Logout from './components/Logout';
import { Button, Row, Col } from 'reactstrap';
import './App.css';
import { Title } from './components/Title';
import { makeCall } from './auth-utils';
import { Layout } from './components/Shared/Layout';
import { LoginModal } from './components/LoginModal';
import { Callback } from './components/Shared/Callback';
import { Embed } from './components/Inquiries/Embed';
import { InquiryForm } from './components/Inquiries/InquiryForm';
import { Admin } from './components/Admin/Admin';

export const AppName = "Resource Center";
export const AppAbbreviation = "SRC";

export const App = (props) => {
    const ls = require('local-storage');
    const [redirect, setRedirect] = useState('');
    const [noAccess, setNoAccess] = useState(true);
    const [loggedOut, setLoggedOut] = useState(false);
    const [unableToConnect, setUnableToConnect] = useState('');
    const [user, setUser] = useState(null);
    const [access, setAccess] = useState(null);
    const [userName, setUserName] = useState(null);
    const [showPrimaryMenu, setShowPrimaryMenu] = useState(true);
    const [loggingInMessage, setLoggingInMessage] = useState(null);
    const [errorGettingUser, setErrorGettingUser] = useState(false);
    const isCallback = window.location.pathname === '/aad-callback';

    return (isCallback ?
        <Layout CurrentUser={user} Access={access} ShowPrimaryMenu={showPrimaryMenu}>
            <Switch>
                <Route exact path='/aad-callback' render={(props) => {
                    return (<Callback {...props} />);
                }} />
            </Switch>
        </Layout>
        :
        <Switch>
            <Route exact path='/' render={(props) => <InquiryForm {...props} />} />
            <Route path='/admin' render={(props) => <Admin {...props} />} />
            <Route exact path='/logout' render={(props) =>
                <Layout CurrentUser={user} Access={access} ShowPrimaryMenu={showPrimaryMenu}><Logout ClearAccess={() => {
                    setAccess(null);
                }} />
                </Layout>
            } />
        </Switch>
    );
};

//export default App;


// WEBPACK FOOTER //
// ./src/App.js